import { Link } from "react-router-dom";
import { buttonClass, Card } from "@promptgatewaysadmin/ui";
import { useSubscriptionState } from "../../queries/hooks.js";
import { daysLeft } from "../../api/normalise.js";
import { config } from "../../config.js";

/**
 * /checkout/cancelled — Stripe's cancel_url.
 *
 * Without this route, backing out of Stripe lands on a 404, which reads as "something went
 * wrong with my payment".
 *
 * "Nothing was charged." comes FIRST — it is the only question the customer has. The second
 * sentence adapts to their status. There is no retention offer and no "are you sure": they
 * already answered.
 */
export function CheckoutCancelled() {
  const sub = useSubscriptionState();
  const state = sub.data;
  const days = daysLeft(state?.trialEndsAt ?? null);

  const second =
    state?.status === "locked"
      ? "Your team's access is still paused."
      : state?.status === "active"
        ? "Your current plan is unchanged."
        : days !== null && days > 0
          ? `Your trial is still running — ${days} day${days === 1 ? "" : "s"} left.`
          : "Your trial is still running.";

  return (
    <Card title="Checkout cancelled">
      <p className="pg-card__body">
        <strong>Nothing was charged.</strong> {second}
      </p>
      <div className="pg-form__actions">
        <a className={buttonClass("secondary")} href={`${config.siteOrigin}/pricing`}>
          Back to plans
        </a>
        <Link className={buttonClass("primary")} to="/">
          Go to dashboard
        </Link>
      </div>
    </Card>
  );
}
